import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const jsonCodec = <T extends z.core.$ZodType>(schema: T) =>
	z.codec(z.string(), schema, {
		decode: (jsonString, ctx) => {
			try {
				// eslint-disable-next-line @typescript-eslint/no-unsafe-return
				return JSON.parse(jsonString);
			} catch (err: unknown) {
				const error = err instanceof Error ? err : new Error('Unknown error parsing JSON');
				ctx.issues.push({
					code: 'invalid_format',
					format: 'json',
					input: jsonString,
					message: error.message,
				});
				return z.NEVER;
			}
		},
		encode: (value) => JSON.stringify(value),
	});
